<template>
  <div class="estat-shell">
    <div id="dropdown" />
    <div class="estat-header-backdrop" aria-hidden="true"></div>
    <button v-if="menuOpen" class="estat-sidebar-overlay" aria-label="Close navigation" @click="menuOpen = false"></button>
    <aside
      id="estat-navigation"
      class="estat-sidebar"
      :class="{ 'is-open': menuOpen }"
      @touchstart.passive="startDrawerSwipe"
      @touchend.passive="endDrawerSwipe"
      @touchcancel.passive="drawerSwipe = null"
    >
      <Link href="/" class="estat-brand"><span class="estat-brand-mark">E</span><span>ESTAT Hub<small>Energy Commission of Sabah</small></span></Link>
      <div class="estat-nav-label">WORKSPACE</div>
      <main-menu :auth="userAuth" @click="menuOpen = false" />
      <div class="estat-sidebar-footer">
        <Link href="/logout" method="post" as="button" type="button" class="estat-mobile-logout" @click="menuOpen = false">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M9 4H4v16h5M14 8l4 4-4 4M8 12h10" stroke-linecap="round" stroke-linejoin="round" /></svg>
          <span>Log Out</span>
        </Link>
        <div><span class="estat-status-dot"></span> ECoS Energy Statistics</div>
      </div>
    </aside>
    <div class="estat-main">
      <header class="estat-topbar">
        <div class="estat-topbar-heading">
          <button class="estat-menu-toggle" type="button" aria-label="Toggle navigation" :aria-expanded="menuOpen" aria-controls="estat-navigation" @click="menuOpen = !menuOpen"><span></span><span></span><span></span></button>
          <div><div class="estat-breadcrumb">ESTAT / {{ pageTitle }}</div><strong>{{ pageTitle }}</strong></div>
        </div>
        <dropdown placement="bottom-end">
          <template #default><span class="estat-user"><img v-if="user.photo" :src="user.photo" alt="" /><span v-else class="estat-avatar">{{ initials }}</span><span>{{ user.first_name || 'Account' }} {{ user.last_name || '' }}</span><span aria-hidden="true">⌄</span></span></template>
          <template #dropdown><div class="estat-account-menu"><Link href="/profile">Profile</Link><Link href="/logout" method="post" as="button">Log Out</Link></div></template>
        </dropdown>
      </header>
      <main class="estat-page" scroll-region><flash-messages /><slot /></main>
      <footer class="estat-footer">© {{ new Date().getFullYear() }} Energy Commission of Sabah <span>ESTAT Hub</span></footer>
    </div>
  </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
export default {
  components: { Link, Dropdown, MainMenu, FlashMessages },
  props: { auth: Object },
  data() { return { menuOpen: false, drawerSwipe: null } },
  computed: {
    userAuth() { return this.auth || this.$page.props.auth || {} },
    user() { return this.userAuth.user || {} },
    initials() { return ((this.user.first_name || 'E')[0] + (this.user.last_name || '') .slice(0, 1)).toUpperCase() },
    pageTitle() {
      const path = this.$page.url.split('?')[0].split('/').filter(Boolean)[0] || ''
      return ({ licenses: 'Licenses', reports: 'Reports', profile: 'Profile', guidelines: 'User Manual', users: 'Users', '': 'Dashboard' })[path] || 'ESTAT Hub'
    },
  },
  methods: {
    startDrawerSwipe(event) {
      this.drawerSwipe = null
      if (!this.menuOpen || event.touches.length !== 1) return
      const touch = event.touches[0]
      this.drawerSwipe = { x: touch.clientX, y: touch.clientY, id: touch.identifier }
    },
    endDrawerSwipe(event) {
      const start = this.drawerSwipe
      this.drawerSwipe = null
      if (!this.menuOpen || !start || event.touches.length) return
      const touch = Array.from(event.changedTouches).find(item => item.identifier === start.id)
      if (!touch) return
      const dx = touch.clientX - start.x
      const dy = touch.clientY - start.y
      // Require a deliberate left swipe; leave vertical scrolling native.
      if (dx < -60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.menuOpen = false
    },
  },
  watch: { '$page.url'() { this.menuOpen = false; this.drawerSwipe = null } },
}
</script>

<style scoped>
.estat-mobile-logout { display:none; }
@media (max-width:1023px) {
  .estat-mobile-logout { display:flex;align-items:center;justify-content:center;gap:10px;width:100%;margin-bottom:20px;padding:12px 16px;border:1px solid #f3c6ce;border-radius:10px;background:#fff1f3;color:#bd304c;font-size:14px;font-weight:700;cursor:pointer; }
  .estat-mobile-logout svg { width:20px;height:20px;flex-shrink:0; }
  .estat-mobile-logout:hover { background:#ffe3e9; }
  .estat-mobile-logout:focus-visible { outline:2px solid #bd304c;outline-offset:3px; }
}
</style>